/* VeteNa: refuerzo del filtro de fotos por color (el filtro principal está en vetena-color-selection.js).
   Al elegir un color solo se ven: las fotos de ese color y las dos del packaging.
   1) Fotos con el color en el texto alternativo cuyo color NO es una opción del producto: se ocultan.
   2) Fotos compartidas por varios colores ("Rojo/Morado/Negro - ..."): se ven al elegir cualquiera de ellos.
   3) Una foto cuyo texto alternativo empieza por el color elegido siempre se ve.
   4) Fotos generales o de grupo (sin texto alternativo, o con uno que no empieza por un color) se ocultan,
      salvo la primera de la galería (la del color elegido).
   5) Sin parpadeo: al pulsar un color la galería se oculta ~0,5 s y se muestra ya filtrada; además cualquier cambio
      en la galería se vuelve a filtrar al instante, antes de que se pinte. */
(() => {
  if (window.vetenaColorExtraLoaded) return;
  window.vetenaColorExtraLoaded = true;
  const sel = '[data-vetena-required-color]';
  const GALLERY = '.product__media-list, .thumbnail-list';

  const st = document.createElement('style');
  st.textContent = 'html.vt-gal-busy .product__media-list,html.vt-gal-busy .thumbnail-list{opacity:0!important;transition:none!important}.product__media-list,.thumbnail-list{transition:opacity .2s ease}';
  document.head.appendChild(st);

  function selectedColor(pi) {
    const c = pi.querySelector(sel);
    if (!c) return null;
    const checked = c.querySelector('input[type=radio]:checked');
    if (checked) return (checked.value || '').trim() || null;
    const s = c.querySelector('select');
    if (s) {
      const o = s.selectedOptions && s.selectedOptions[0];
      if (!o || o.hasAttribute('data-vetena-color-placeholder')) return null;
      return (s.value || '').trim() || null;
    }
    return null;
  }

  function knownColors(pi) {
    const set = new Set();
    pi.querySelectorAll(sel + ' input[type=radio], ' + sel + ' option').forEach((e) => {
      const v = (e.value || '').trim().toLowerCase();
      if (v) set.add(v);
    });
    return set;
  }

  function setSlide(slide, show) {
    if (slide.hidden === !show && slide.style.display === (show ? '' : 'none')) return;
    slide.hidden = !show;
    slide.style.display = show ? '' : 'none';
  }

  function pass(pi) {
    const chosen = selectedColor(pi);
    if (!chosen) return;
    const sel1 = chosen.toLowerCase();
    const known = knownColors(pi);
    let map = {};
    const mapEl = pi.querySelector('[data-vetena-media-color-map]');
    if (mapEl) {
      try { map = JSON.parse(mapEl.textContent); } catch (e) { map = {}; }
    }
    pi.querySelectorAll('.product__media-item[data-media-id], .thumbnail-list__item[data-target]').forEach((slide) => {
      const id = (slide.dataset.mediaId || slide.dataset.target || '').split('-').pop();
      const img = slide.querySelector('img');
      const alt = ((img && img.alt) || '').trim();
      if (slide.hasAttribute('data-vetena-packaging')) return;
      if (/^(cajita de regalo|packaging y unboxing)/i.test(alt)) return;
      const isFirst = slide.parentElement && slide.parentElement.firstElementChild === slide;
      const m = alt.match(/^(.{2,90}?) - /);
      if (!alt || !m) {
        if (!isFirst && map[id] === undefined) setSlide(slide, false);
        return;
      }
      const prefix = m[1].trim().toLowerCase();
      if (known.has(prefix)) {
        if (prefix === sel1) setSlide(slide, true);
        return;
      }
      const parts = prefix.split('/').map((p) => p.trim()).filter(Boolean);
      if (parts.length > 1 && parts.every((p) => known.has(p))) {
        setSlide(slide, parts.indexOf(sel1) >= 0);
        return;
      }
      if (map[id] === undefined && prefix.length <= 24) {
        setSlide(slide, false);
      }
    });
  }

  function passAll() {
    document.querySelectorAll('product-info').forEach(pass);
  }

  /* Cualquier cambio en la galería se vuelve a filtrar en el acto (antes de pintar). */
  let obs = null;
  function runPass() {
    passAll();
    if (obs) obs.takeRecords();
  }

  function startObserver() {
    if (obs) return;
    obs = new MutationObserver((records) => {
      const inGallery = records.some((r) => {
        const t = r.target && r.target.nodeType === 1 ? r.target : r.target && r.target.parentElement;
        return t && t.closest && (t.closest(GALLERY) || t.matches('product-info, .product__media-wrapper'));
      });
      if (inGallery) runPass();
    });
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden', 'style', 'data-media-id']
    });
  }

  /* Galería oculta como máximo ~0,55 s desde la primera pulsación (la plantilla vuelve a lanzar eventos de cambio). */
  let busyTimer = null;
  let busyStart = 0;
  function startBusy() {
    const now = Date.now();
    if (!document.documentElement.classList.contains('vt-gal-busy') || now - busyStart > 700) busyStart = now;
    document.documentElement.classList.add('vt-gal-busy');
    clearTimeout(busyTimer);
    const wait = Math.max(80, Math.min(520, busyStart + 560 - now));
    busyTimer = setTimeout(() => {
      runPass();
      document.documentElement.classList.remove('vt-gal-busy');
    }, wait);
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.closest && t.closest(sel)) startBusy();
    setTimeout(passAll, 150);
    setTimeout(passAll, 700);
  }, true);

  function init() {
    startObserver();
    setTimeout(passAll, 200);
    setTimeout(passAll, 800);
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();